import Angle from "../../../../../../../src/entities/Angle/Angle";
import getDistanceBtwPoints from "../../../../../../../src/utils/getDistanceBtwPoints";
import { AngleDrawParams} from "../../../types/Interface";


export function drawAngle(angle: Angle, aPms: AngleDrawParams, clockwise: boolean) { //aPms = angleParams
  const smllDistance = Math.min(getDistanceBtwPoints(aPms.points.curr, aPms.points.prev), getDistanceBtwPoints(aPms.points.curr, aPms.points.next));
  angle.smallDistance = Math.floor(smllDistance);
  angle.draw(aPms.points.curr, aPms.startRadian, aPms.endRadian, aPms.degree, clockwise);
  angle.x = aPms.points.curr.x;
  angle.y = aPms.points.curr.y;
  angle.rotation = 0;
}